<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import A from "../lib/Router/A.svelte";
    import DepartmentSelect from "../components/controls/DepartmentSelect.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import DepartmentSelectModal from "../departments/DepartmentSelectModal.svelte";

    export let hotel = null;
    export let changeHandler = null;

    let selectedDepartments = null;

    const save = (departmentIds) => {
        const onSuccess = result => {
            if (result.length < hotel.departments.length) {
                Notifier.showMessage("Department removed from hotel");
            } else {
                Notifier.showMessage("Department related to hotel");
            }
            hotel.departments = result;
            if (changeHandler) {
                changeHandler(hotel.departments);
            }
        }

        const onFailure = err => {
            Alert.warning("Hotel", err.message);
        };


        R.handle(R.hotel.editDepartments, {
            id: hotel.id,
            departments: departmentIds
        }, onSuccess, onFailure, LOADER.POPUP);
    }


    const onAdd = ({detail}) => {
        let ids = [detail.id, ...hotel.departments.map(item => (item.id))];
        save(ids);
    }

    const onRemove = (depObj) => {
        Alert.confirm("Remove department", `This will remove department "${depObj.name}" from hotel.\nAre you sure?`, () => removeDepartment(depObj.id));
    }

    const removeDepartment = (id) => {
        let ids = hotel.departments.map(item => (item.id)).filter(x => x != id);
        save(ids);
    }

    const openModal = () => {
        console.log("openModal");
        selectedDepartments = hotel.departments.map(item => (item.id));
        console.log(selectedDepartments);
    }

    const closeModal = (selected) => {
        if (selected) {
            save(selected);
        }
        selectedDepartments = null;
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Departments
    </div>
    {#if hotel.id > 0}
        <div class="panel-body p-2 border-bottom">
            <div class="tools-box">
                <DepartmentSelect excludeFromSelection="{ hotel.departments }" on:select="{ onAdd }"
                              placeholder="add existing department"/>
                <button class="btn btn-default btn-flex line-height-1 ms-1" title="select from list" on:click="{ openModal }">
                    <AppIcon icon="list" size="16"/>
                </button>
            </div>
        </div>
        {#if hotel.departments.length}
            <table class="table table-list">
                <tbody>
                {#each hotel.departments as item}
                    <tr class="row-hover">
                        <td>
                            <A href="/app/department/{ item.id }">
                                <ColoredNameControl name="{ item.name }"
                                                    color="{ item.color }"
                                                    colorName isLink
                                                    isActive="{ item.is_active  }"/>
                            </A>
                        </td>
                        <td class="button-column pointer" title="remove department from hotel" on:click="{ () => onRemove(item) }">
                            <AppIcon icon="x" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new hotel in order to add departments
        </div>
    {/if}
</div>
{#if selectedDepartments != null}
    <DepartmentSelectModal selected={ selectedDepartments } callbackHandler="{ closeModal }"/>
{/if}